<template>
    <p><span v-text="item.label"></span><span :class="{'colFF7A45': item.colTrue}" v-text="item.content"></span></p>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => {
                return {}
            }
        }
    }
}
</script>

<style lang="scss" scoped>
p {
    display: flex;
    justify-content: start;
    font-size: 24px;
    span {
        font-size: 28px;
        color: #000;
        word-wrap:break-word;
        word-break:break-all;
        overflow: hidden;
        &:first-child {
            color: #666;
            flex: 0 0 152px;
            text-align: left;
        }
        &.colFF7A45 {
            color: #FF7A45;
        }
    }
    &:not(:last-child) {
        margin-bottom: 24px;
    }
}
</style>